<template>
<b-container id="body" fluid>
<b-row>
  
<b-col cols='4' class="offset-md-4" id="contents">
  <div id="logo">ADMIN</div>
<b-form-input id="email" type="text" size="sm" placeholder="Email"></b-form-input>
<b-form-input id="password" type="password" size="sm" placeholder="password"></b-form-input>
<button @click="login">Login</button>
</b-col>

</b-row>
</b-container>
</template>
<script>
import {auth} from '../firebase'

export default {

  data () {
    return {

    }
  },
  methods:{
    login: function(){
      var email = document.getElementById('email').value 
      var password = document.getElementById('password').value 

      auth.signInWithEmailAndPassword(email, password).then(user => {
     
      auth.currentUser.getIdTokenResult()
      .then((idTokenResult) => {

        //console.log(idTokenResult.claims.admin)
        if (!!idTokenResult.claims.admin) {
       
       this.$router.replace({name: "admin"});
          
        } else {
       
          console.log("invalid user")
        }
      })
      .catch((error) => {
        console.log(error);
      })
      })

    }
  }
}
</script>
<style scoped>

html,body{
  width: 100%;
  height: 100%;
  background: gainsboro;
}
#body{
  position: relative;
  background: gainsboro;
  width: 105%;
  height: 120%;
  left: -3%;
}
#logo{
  font-size: 100px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 30px;

}

#contents{
  background: #fff;
  margin-top: 6%;
  border: 1px solid slategray;
  border-radius: 5px;
  margin-bottom: 7%;
}

#email{
  margin-bottom: 10px;
}

#password{
  margin-bottom: 10px;
}

#loginbtn{
  width: 100%;
  padding: 10px;
  margin-bottom: 40px;
  color: white;
  background: slateblue;
}


</style>
